import { OAuthResponse } from "../../types/Authentication";

type AuthenticationArguments = {
  enterpriseId: string;
  enterpriseSecret: string;
  authenticationUrl?: string;
};

export const authenticate =
  ({
    enterpriseId,
    enterpriseSecret,
    authenticationUrl = "https://dev-sgghwrhkwi5ubfpz.us.auth0.com/oauth/token",
  }: AuthenticationArguments) =>
  (): Promise<OAuthResponse> => {
    const params = {
      client_id: enterpriseId,
      client_secret: enterpriseSecret,
      grant_type: "client_credentials",
      audience: "https://app.accelbooks.ai",
    };

    // Log the URL to debug


    // Ensure the URL is absolute by hardcoding for testing
    const testUrl = "https://dev-sgghwrhkwi5ubfpz.us.auth0.com/oauth/token";

    return fetch(testUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(params),
    }).then((response) => response.json() as Promise<OAuthResponse>);
  };
